import { Tag } from '@fasstech/middle-design-system';

const GranteesErrorMessage = ({ granteesWithErrors = [] }) => {
  if (!granteesWithErrors.length) {
    return null;
  }

  return (
    <div>
      <div>Veuillez vérifier votre saisie pour le ou les bénéficiaire(s) :</div>

      <ul className="mt-1 flex flex-col gap-1 list-disc pl-6">
        {granteesWithErrors.map(({ label, tag }) => (
          <li key={`${label}-${tag}`}>
            <div className="inline-flex items-center gap-2">
              <span>{label}</span>
              {tag && (
                <span className="[&>div]:text-black!">
                  <Tag label={tag} variant="neutral" />
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default GranteesErrorMessage;
